import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add1",
  "use": "icon-add1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add1\"><path d=\"M512 0a512 512 0 1 0 512 512A512.557127 512.557127 0 0 0 512 0z m0 912.574538a400.574538 400.574538 0 1 1 400.574538-400.574538 401.131665 401.131665 0 0 1-400.574538 400.574538z\" p-id=\"65649\" /><path d=\"M690.837867 456.287269h-111.425462v-111.425463a55.712731 55.712731 0 1 0-111.425463 0v111.425463h-111.425462a55.712731 55.712731 0 0 0 0 111.425462h111.425462v111.425463a55.712731 55.712731 0 1 0 111.425463 0v-111.425463h111.425462a55.712731 55.712731 0 0 0 0-111.425462z\" p-id=\"65650\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/add1.svg
// module id = 1HcA
// module chunks = 252